import { AssetManagerContext } from "./context"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import { fetchRoute } from "cakemail-ui-components-v2"
import TemplatesListing from "../templates/listing"
import TemplateDetails from "../templates/details"


export default function AssetManager({ ...props }) {
    return <AssetManagerContext.Provider value={{}}
    >
        <Routes>
            <Route path={fetchRoute({ route: ERoutes.assets }) + "/*"} element={<TemplatesListing />} />
            <Route path={fetchRoute({ route: ERoutes.templateDetails }) + "/*"} element={<TemplateDetails />} />

            <Route index element={<TemplatesListing />} />
            <Route path={"/templates/:templateId/details/*"} element={<TemplateDetails />} />
        </Routes>
    </AssetManagerContext.Provider>
}